import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ScanEffects, scanDocumentReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([ScanEffects]), StoreModule.forFeature('scanDocument', scanDocumentReducer)]
})
export class ScanStateModule {}
